import React from "react";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";

import { IOrganization, ITeam } from "@src/types/api";

import OrgIndex from "@LeagueManagement/Organizations/components/OrgIndex";
import { OrganizationsProvider } from "@LeagueManagement/Organizations/contexts/OrganizationsContext";

const OrganizationIndex = (): React.JSX.Element | undefined => {
    const location = useLocation();

    const { organizations, teams } = useLoaderData() as {
        organizations?: IOrganization[];
        teams?: ITeam[];
    };

    const isOnOrgPage = /organizations\/?$/.test(location.pathname);

    return (
        <OrganizationsProvider organizations={organizations} teams={teams}>
            {isOnOrgPage ? <OrgIndex /> : <Outlet />}
        </OrganizationsProvider>
    );
};

export default OrganizationIndex;
